"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const o=require("./CustomDialog.js"),e=require("./Dialog.js");exports.CustomDialog=o;exports.Dialog=e;exports.default=e;
//# sourceMappingURL=index.js.map
